<template>
  <!-- 正常额度table | 临时额度table-->
  <a-table
    v-if="show"
    :columns="loanColumns"
    :data-source="dataSource"
    :pagination="false"
    :scroll="SCROLL"
    row-key="id"
    bordered
  >
    <!-- 自定义渲染表头的title行 -->
    <label
      v-for="titleItem in customTitleList"
      :key="titleItem.keyName"
      :for="`${TABLE_NAME}_${titleItem.keyName}`"
      :slot="`${titleItem.keyName}Title`"
      class="ant-form-item-required"
    >
      {{ titleItem.title }}
    </label>

    <span slot="type">{{ typeText }}</span>
    <span slot="amount" slot-scope="text">{{ text | formatAmount }}</span>
    <span slot="totalWithRoadAmount" slot-scope="text, record">
      {{ loadTotalWithRoadAmount(record) | formatAmount }}
    </span>
    <span slot="indateEnd" slot-scope="text">至 {{ text }}</span>

    <!-- 货币 -->
    <template slot="moneyId" slot-scope="text, record">
      <span v-if="record.moneyId == 0">
        人民币
      </span>
      <span v-else>
        {{ record.moneyName }}
      </span>
    </template>

  </a-table>
</template>

<script>
import { CREDIT_TYPE_OBJ, CREDIT_TYPE_VALUE_OBJ } from '../../const'
import {
  TYPE_WIDTH,
  AMOUNT_WIDTH,
  TOTAL_AMOUNT_WIDTH,
  INDATE_WIDTH,
  TERM_WIDTH,
  SCROLL,
} from './config'
import { getChangeMount } from '../../apply/api'
const TABLE_NAME = 'specialTable'

export default {
  name: 'SpecialTable',
  data() {
    return {
      TABLE_NAME,
      SCROLL,
      rate: '',
      loanColumns: [
        {
          title: '信用类型',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          width: TYPE_WIDTH,
        },
        {
          dataIndex: 'amount',
          slots: { title: 'amountTitle' },
          scopedSlots: { customRender: 'amount' },
          width: AMOUNT_WIDTH,
        },
        {
          dataIndex: 'moneyId',
          slots: { title: 'moneyIdTitle' },
          scopedSlots: { customRender: 'moneyId' },
          width: TERM_WIDTH,
        },
        {
          title: '申请后集团总额度(RMB元)',
          dataIndex: 'totalWithRoadAmount',
          scopedSlots: { customRender: 'totalWithRoadAmount' },
          width: TOTAL_AMOUNT_WIDTH,
        },
        {
          dataIndex: 'indateEnd',
          slots: { title: 'indateEndTitle' },
          scopedSlots: { customRender: 'indateEnd' },
          width: INDATE_WIDTH,
        },
        {
          dataIndex: 'term',
          slots: { title: 'termTitle' },
          scopedSlots: { customRender: 'term' },
          width: TERM_WIDTH,
        },
      ],
      // 自定义表头中title
      customTitleList: [
        {
          title: '本次申请增加额度(元)',
          keyName: 'amount',
        },
        {
          title: '货币',
          keyName: 'moneyId',
        },
        {
          title: '额度有效期',
          keyName: 'indateEnd',
        },
        {
          title: '账期(天)',
          keyName: 'term',
        },
      ],
      specialIdTotalObj: {},
    }
  },
  props: ['type', 'dataSource', 'baseInfo'],
  computed: {
    show() {
      const type = this.type
      return (
        type == CREDIT_TYPE_VALUE_OBJ.SPECIAL_TYPE ||
        type == CREDIT_TYPE_VALUE_OBJ.CREDIT_SPECIAL_TYPE
      )
    },
    typeText() {
      return CREDIT_TYPE_OBJ[CREDIT_TYPE_VALUE_OBJ.SPECIAL_TYPE]
    },
  },

  methods: {
    loadTotalWithRoadAmount(row) {
      const amount = row.amount || 0
      const loanAmountFinal = row.loanAmountFinal
      const baseInfo = this.baseInfo
      if (baseInfo) {
        const running = baseInfo.running
        if (running == 1) {
          const groupTotalAmount = this.baseInfo.groupTotalAmount || 0
          if(row.moneyId == 0 || row.moneyId == null){
            const total = parseFloat(amount) + parseFloat(groupTotalAmount)
            this.specialIdTotalObj[row.id] = total
            return total
          }else{
          //获取货币转化比率
          getChangeMount(row.moneyId).then(({ data }) => {
            this.rate = data || 0
          })
          return parseFloat(row.amount * this.rate) + parseFloat(groupTotalAmount)
          }
        }
        this.specialIdTotalObj[row.id] = loanAmountFinal
        return loanAmountFinal
      }
      return 0
    },
    getTotalWithRoadAmount() {
      const specialIdTotalObj = this.specialIdTotalObj
      let total = 0
      for (let id in specialIdTotalObj) {
        total += specialIdTotalObj[id]
      }
      return total
    },
  },
}
</script>

<style></style>
